module.exports = __webpack_public_path__ + "media/images/new-black-logo-56a1ce705c16b4b30320b18189b4edb7.png";